import _defineProperty from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import $fzaAv$react from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $eb2240fc39a57fa5$export$bf788dd355e3a401 = /*#__PURE__*/function () {
  function $eb2240fc39a57fa5$export$bf788dd355e3a401() {
    _classCallCheck(this, $eb2240fc39a57fa5$export$bf788dd355e3a401);

    this.cache = new WeakMap();
  }

  return _createClass($eb2240fc39a57fa5$export$bf788dd355e3a401, [{
    key: "build",
    value: function build(props, context) {
      var _this = this;

      this.context = context;
      return $eb2240fc39a57fa5$var$iterable(function () {
        return _this.iterateCollection(props);
      });
    }
  }, {
    key: "iterateCollection",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function iterateCollection(props) {
      var children, items, index, _iterator, _step, item, _items, _index, _i, _items2, _item, nodes, _iterator2, _step2, node;

      return _regeneratorRuntime.wrap(function iterateCollection$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            children = props.children, items = props.items;

            if (!((0, $fzaAv$react).isValidElement(children) && children.type === (0, $fzaAv$react).Fragment)) {
              _context.next = 5;
              break;
            }

            return _context.delegateYield(this.iterateCollection({
              children: children.props.children,
              items: items
            }), "t0", 3);

          case 3:
            _context.next = 56;
            break;

          case 5:
            if (!(typeof children === 'function')) {
              _context.next = 28;
              break;
            }

            if (items) {
              _context.next = 8;
              break;
            }

            throw new Error('props.children was a function but props.items is missing');

          case 8:
            index = 0;
            _iterator = _createForOfIteratorHelper(items);
            _context.prev = 10;

            _iterator.s();

          case 12:
            if ((_step = _iterator.n()).done) {
              _context.next = 18;
              break;
            }

            item = _step.value;
            return _context.delegateYield(this.getFullNode({
              value: item,
              index: index
            }, {
              renderer: children
            }), "t1", 15);

          case 15:
            index++;

          case 16:
            _context.next = 12;
            break;

          case 18:
            _context.next = 23;
            break;

          case 20:
            _context.prev = 20;
            _context.t2 = _context["catch"](10);

            _iterator.e(_context.t2);

          case 23:
            _context.prev = 23;

            _iterator.f();

            return _context.finish(23);

          case 26:
            _context.next = 56;
            break;

          case 28:
            _items = [];
            (0, $fzaAv$react).Children.forEach(children, function (child) {
              if (child) _items.push(child);
            });
            _index = 0;
            _i = 0, _items2 = _items;

          case 32:
            if (!(_i < _items2.length)) {
              _context.next = 56;
              break;
            }

            _item = _items2[_i];
            nodes = this.getFullNode({
              element: _item,
              index: _index
            }, {});
            _iterator2 = _createForOfIteratorHelper(nodes);
            _context.prev = 36;

            _iterator2.s();

          case 38:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 45;
              break;
            }

            node = _step2.value;
            _index++;
            _context.next = 43;
            return node;

          case 43:
            _context.next = 38;
            break;

          case 45:
            _context.next = 50;
            break;

          case 47:
            _context.prev = 47;
            _context.t3 = _context["catch"](36);

            _iterator2.e(_context.t3);

          case 50:
            _context.prev = 50;

            _iterator2.f();

            return _context.finish(50);

          case 53:
            _i++;
            _context.next = 32;
            break;

          case 56:
          case "end":
            return _context.stop();
        }
      }, iterateCollection, this, [[10, 20, 23, 26], [36, 47, 50, 53]]);
    })
  }, {
    key: "getKey",
    value: function getKey(item, partialNode, state, parentKey) {
      if (item.key != null) return item.key;
      if (partialNode.type === 'cell' && partialNode.key != null) return "".concat(parentKey).concat(partialNode.key);
      var v = partialNode.value;

      if (v != null) {
        var _v_key;

        var key = (_v_key = v.key) !== null && _v_key !== void 0 ? _v_key : v.id;
        if (key == null) throw new Error('No key found for item');
        return key;
      }

      return parentKey ? "".concat(parentKey, ".").concat(partialNode.index) : "$.".concat(partialNode.index);
    }
  }, {
    key: "getChildState",
    value: function getChildState(state, partialNode) {
      return {
        renderer: partialNode.renderer || state.renderer
      };
    }
  }, {
    key: "getFullNode",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function getFullNode(partialNode, state, parentKey, parentNode) {
      var children, _partialNode_index, index, _i2, _children, child, element, cached, type, name, childNodes, _partialNode_index1, _index2, result, childNode, _childNode_key, nodeKey, nodes, _children2, _iterator3, _step3, _node, _childNode_value, _ref, _parentNode_type, builder, _partialNode_value, _partialNode_textValue, node;

      return _regeneratorRuntime.wrap(function getFullNode$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!((0, $fzaAv$react).isValidElement(partialNode.element) && partialNode.element.type === (0, $fzaAv$react).Fragment)) {
              _context3.next = 12;
              break;
            }

            children = [];
            (0, $fzaAv$react).Children.forEach(partialNode.element.props.children, function (child) {
              children.push(child);
            });
            index = (_partialNode_index = partialNode.index) !== null && _partialNode_index !== void 0 ? _partialNode_index : 0;
            _i2 = 0, _children = children;

          case 5:
            if (!(_i2 < _children.length)) {
              _context3.next = 11;
              break;
            }

            child = _children[_i2];
            return _context3.delegateYield(this.getFullNode({
              element: child,
              index: index++
            }, state, parentKey, parentNode), "t0", 8);

          case 8:
            _i2++;
            _context3.next = 5;
            break;

          case 11:
            return _context3.abrupt("return");

          case 12:
            // If there's a value instead of an element on the node, and a parent renderer function is available,
            // use it to render an element for the value.
            element = partialNode.element;

            if (!(!element && partialNode.value && state && state.renderer)) {
              _context3.next = 22;
              break;
            }

            cached = this.cache.get(partialNode.value);

            if (!(cached && (!cached.shouldInvalidate || !cached.shouldInvalidate(this.context)))) {
              _context3.next = 21;
              break;
            }

            cached.index = partialNode.index;
            cached.parentKey = parentNode ? parentNode.key : null;
            _context3.next = 20;
            return cached;

          case 20:
            return _context3.abrupt("return");

          case 21:
            element = state.renderer(partialNode.value);

          case 22:
            if (!(0, $fzaAv$react).isValidElement(element)) {
              _context3.next = 63;
              break;
            }

            type = element.type;

            if (!(typeof type !== 'function' && typeof type.getCollectionNode !== 'function')) {
              _context3.next = 27;
              break;
            }

            name = element.type;
            throw new Error("Unknown element <".concat(name, "> in collection."));

          case 27:
            childNodes = type.getCollectionNode(element.props, this.context);
            _index2 = (_partialNode_index1 = partialNode.index) !== null && _partialNode_index1 !== void 0 ? _partialNode_index1 : 0;
            result = childNodes.next();

          case 30:
            if (!(!result.done && result.value)) {
              _context3.next = 62;
              break;
            }

            childNode = result.value;
            partialNode.index = _index2;
            nodeKey = (_childNode_key = childNode.key) !== null && _childNode_key !== void 0 ? _childNode_key : null;
            if (nodeKey == null) nodeKey = childNode.element ? null : this.getKey(element, partialNode, state, parentKey);
            nodes = this.getFullNode(_objectSpread(_objectSpread({}, childNode), {}, {
              key: nodeKey,
              index: _index2,
              wrapper: $eb2240fc39a57fa5$var$compose(partialNode.wrapper, childNode.wrapper)
            }), this.getChildState(state, childNode), parentKey ? "".concat(parentKey).concat(element.key) : element.key, parentNode);
            _children2 = _toConsumableArray(nodes);
            _iterator3 = _createForOfIteratorHelper(_children2);
            _context3.prev = 38;

            _iterator3.s();

          case 40:
            if ((_step3 = _iterator3.n()).done) {
              _context3.next = 51;
              break;
            }

            _node = _step3.value;
            // Cache the node based on its value
            _node.value = (_ref = (_childNode_value = childNode.value) !== null && _childNode_value !== void 0 ? _childNode_value : partialNode.value) !== null && _ref !== void 0 ? _ref : null;
            if (_node.value) this.cache.set(_node.value, _node);

            if (!(partialNode.type && _node.type !== partialNode.type)) {
              _context3.next = 46;
              break;
            }

            throw new Error("Unsupported type <".concat($eb2240fc39a57fa5$var$capitalize(_node.type), "> in <").concat($eb2240fc39a57fa5$var$capitalize((_parentNode_type = parentNode === null || parentNode === void 0 ? void 0 : parentNode.type) !== null && _parentNode_type !== void 0 ? _parentNode_type : 'unknown parent type'), ">. Only <").concat($eb2240fc39a57fa5$var$capitalize(partialNode.type), "> is supported."));

          case 46:
            _index2++;
            _context3.next = 49;
            return _node;

          case 49:
            _context3.next = 40;
            break;

          case 51:
            _context3.next = 56;
            break;

          case 53:
            _context3.prev = 53;
            _context3.t1 = _context3["catch"](38);

            _iterator3.e(_context3.t1);

          case 56:
            _context3.prev = 56;

            _iterator3.f();

            return _context3.finish(56);

          case 59:
            result = childNodes.next(_children2);
            _context3.next = 30;
            break;

          case 62:
            return _context3.abrupt("return");

          case 63:
            if (!(partialNode.key == null || partialNode.type == null)) {
              _context3.next = 65;
              break;
            }

            return _context3.abrupt("return");

          case 65:
            // Create full node
            builder = this;
            node = {
              type: partialNode.type,
              props: partialNode.props,
              key: partialNode.key,
              parentKey: parentNode ? parentNode.key : null,
              value: (_partialNode_value = partialNode.value) !== null && _partialNode_value !== void 0 ? _partialNode_value : null,
              level: parentNode ? parentNode.level + 1 : 0,
              index: partialNode.index,
              rendered: partialNode.rendered,
              textValue: (_partialNode_textValue = partialNode.textValue) !== null && _partialNode_textValue !== void 0 ? _partialNode_textValue : '',
              'aria-label': partialNode['aria-label'],
              wrapper: partialNode.wrapper,
              shouldInvalidate: partialNode.shouldInvalidate,
              hasChildNodes: partialNode.hasChildNodes || false,
              childNodes: $eb2240fc39a57fa5$var$iterable( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                var index, _iterator4, _step4, _child, _nodes, _iterator5, _step5, _node2;

                return _regeneratorRuntime.wrap(function _callee$(_context2) {
                  while (1) switch (_context2.prev = _context2.next) {
                    case 0:
                      if (!(!partialNode.hasChildNodes || !partialNode.childNodes)) {
                        _context2.next = 2;
                        break;
                      }

                      return _context2.abrupt("return");

                    case 2:
                      index = 0;
                      _iterator4 = _createForOfIteratorHelper(partialNode.childNodes());
                      _context2.prev = 4;

                      _iterator4.s();

                    case 6:
                      if ((_step4 = _iterator4.n()).done) {
                        _context2.next = 30;
                        break;
                      }

                      _child = _step4.value;
                      // Ensure child keys are globally unique by prepending the parent node's key
                      if (_child.key != null) // TODO: Remove this line entirely and enforce that users always provide unique keys.
                        // Currently this line will have issues when a parent has a key `a` and a child with key `bc`
                        // but another parent has key `ab` and its child has a key `c`. The combined keys would result in both
                        // children having a key of `abc`.
                        _child.key = "".concat(node.key).concat(_child.key);
                      _nodes = builder.getFullNode(_objectSpread(_objectSpread({}, _child), {}, {
                        index: index
                      }), builder.getChildState(state, _child), node.key, node);
                      _iterator5 = _createForOfIteratorHelper(_nodes);
                      _context2.prev = 11;

                      _iterator5.s();

                    case 13:
                      if ((_step5 = _iterator5.n()).done) {
                        _context2.next = 20;
                        break;
                      }

                      _node2 = _step5.value;
                      index++;
                      _context2.next = 18;
                      return _node2;

                    case 18:
                      _context2.next = 13;
                      break;

                    case 20:
                      _context2.next = 25;
                      break;

                    case 22:
                      _context2.prev = 22;
                      _context2.t0 = _context2["catch"](11);

                      _iterator5.e(_context2.t0);

                    case 25:
                      _context2.prev = 25;

                      _iterator5.f();

                      return _context2.finish(25);

                    case 28:
                      _context2.next = 6;
                      break;

                    case 30:
                      _context2.next = 35;
                      break;

                    case 32:
                      _context2.prev = 32;
                      _context2.t1 = _context2["catch"](4);

                      _iterator4.e(_context2.t1);

                    case 35:
                      _context2.prev = 35;

                      _iterator4.f();

                      return _context2.finish(35);

                    case 38:
                    case "end":
                      return _context2.stop();
                  }
                }, _callee, null, [[4, 32, 35, 38], [11, 22, 25, 28]]);
              }))
            };
            _context3.next = 69;
            return node;

          case 69:
          case "end":
            return _context3.stop();
        }
      }, getFullNode, this, [[38, 53, 56, 59]]);
    })
  }]);
}(); // Wraps an iterator function as an iterable object, and caches the results.


function $eb2240fc39a57fa5$var$iterable(iterator) {
  var cache = [];
  var iterable = null;
  return _defineProperty({}, Symbol.iterator, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _iterator6, _step6, item, _iterator7, _step7, _item2;

    return _regeneratorRuntime.wrap(function _callee2$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _iterator6 = _createForOfIteratorHelper(cache);
          _context4.prev = 1;

          _iterator6.s();

        case 3:
          if ((_step6 = _iterator6.n()).done) {
            _context4.next = 9;
            break;
          }

          item = _step6.value;
          _context4.next = 7;
          return item;

        case 7:
          _context4.next = 3;
          break;

        case 9:
          _context4.next = 14;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](1);

          _iterator6.e(_context4.t0);

        case 14:
          _context4.prev = 14;

          _iterator6.f();

          return _context4.finish(14);

        case 17:
          if (!iterable) iterable = iterator();
          _iterator7 = _createForOfIteratorHelper(iterable);
          _context4.prev = 19;

          _iterator7.s();

        case 21:
          if ((_step7 = _iterator7.n()).done) {
            _context4.next = 28;
            break;
          }

          _item2 = _step7.value;
          cache.push(_item2);
          _context4.next = 26;
          return _item2;

        case 26:
          _context4.next = 21;
          break;

        case 28:
          _context4.next = 33;
          break;

        case 30:
          _context4.prev = 30;
          _context4.t1 = _context4["catch"](19);

          _iterator7.e(_context4.t1);

        case 33:
          _context4.prev = 33;

          _iterator7.f();

          return _context4.finish(33);

        case 36:
        case "end":
          return _context4.stop();
      }
    }, _callee2, null, [[1, 11, 14, 17], [19, 30, 33, 36]]);
  }));
}

function $eb2240fc39a57fa5$var$compose(outer, inner) {
  if (outer && inner) return function (element) {
    return outer(inner(element));
  };
  if (outer) return outer;
  if (inner) return inner;
}

function $eb2240fc39a57fa5$var$capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
}

export { $eb2240fc39a57fa5$export$bf788dd355e3a401 as CollectionBuilder };